import ButtonPrimary from "shared/Button/ButtonPrimary";
import { motion } from "framer-motion";

const ActionDialog = ({
  isOpen,
  onAction,
  title,
  message,
  actionText = "Okay",
  loading = false,
}: {
  isOpen: boolean;
  onAction: () => Promise<void> | void;
  title: string;
  message: string;
  actionText?: string;
  loading?: boolean;
  disableBackdropClose?: boolean;
}
) => {
  if (!isOpen) return <></>;

  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.3 }}
      className="fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-[1000]"
    >
      <motion.div
        initial={{ scale: 0.9 }}
        animate={{ scale: 1 }}
        exit={{ scale: 0.9 }}
        transition={{ duration: 0.3 }}
        className="bg-white rounded-xl p-6 max-w-sm w-full shadow-xl"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-lg font-semibold text-gray-800 mb-2">{title}</h2>
        <p className="text-sm text-gray-600 mb-4">{message}</p>
        <div className="flex justify-end">
          <ButtonPrimary
            sizeClass="sm"
            onClick={onAction}
            loading={loading}
            disabled={loading}
          >
            {!loading && actionText}
          </ButtonPrimary>
        </div>
      </motion.div>
    </motion.div>
  );
};

export default ActionDialog;